import React from 'react';
import { useReveal } from '../lib/useReveal';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/bVMu1ysL7RbVQBP5vfeWYJ/Pack_de_Maestria_Reiki_y_chakras.png';
const BG_IMG = 'https://cdn.magicpatterns.com/uploads/mw6kDR1fciKdF9Qhz1AMu6/heylloyd-image-1774029715790.png';
export function HeroSection() {
  const [ref1, vis1] = useReveal();
  return <section className="pt-12 pb-8 md:pt-16 md:pb-10 px-5 sm:px-6 overflow-hidden relative flex flex-col justify-center" data-id="element-224">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: `url(${BG_IMG})`
    }} data-id="element-225"></div>
      <div className="absolute inset-0 bg-black/88" data-id="element-226"></div>

      <div ref={ref1} className={`reveal container mx-auto max-w-4xl text-center relative z-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-227">
        {/* Brand */}
        <div className="mb-3" data-id="element-228">
          <span className="text-[#f0c040] text-[10px] md:text-xs font-bold tracking-[0.2em] uppercase" data-id="element-229">
            ⭐ ACADEMIA HOLÍSTICA ARGENTINA ⭐
          </span>
        </div>

        {/* Title */}
        <h1 className="mb-2 font-bold tracking-tight leading-none text-[#eab308]" style={{
        fontFamily: "'Playfair Display', serif"
      }} data-id="element-230">
          <span className="block text-3xl sm:text-4xl md:text-5xl lg:text-6xl" data-id="element-231">
            MEGAPACK
          </span>
          <span className="block text-4xl sm:text-5xl md:text-6xl lg:text-7xl italic" data-id="element-232">
            MAESTRÍA REIKI
          </span>
        </h1>

        {/* Subtitle — concise */}
        <p className="text-white font-bold text-base md:text-lg mb-1" data-id="element-233">
          Tu camino completo en Reiki. Desde hoy.
        </p>
        <p className="text-[#eab308] font-medium text-sm md:text-base mb-4" data-id="element-234">
          Niveles I, II y Maestría — Certificado oficial
        </p>

        {/* Product Image — smaller for mobile */}
        <div className="block mx-auto max-w-[180px] sm:max-w-[280px] md:max-w-sm mb-4" data-id="element-235">
          <div className="relative animate-float" data-id="element-236">
            <div className="absolute -inset-3 bg-[#eab308]/10 rounded-3xl blur-2xl animate-pulse-glow" data-id="element-237"></div>
            <div className="relative p-1 rounded-2xl bg-gradient-to-br from-[#eab308]/30 via-white/5 to-[#eab308]/20 shadow-[0_12px_60px_rgba(234,179,8,0.3)] border border-[#eab308]/20" data-id="element-238">
              <div className="rounded-xl overflow-hidden bg-black" data-id="element-239">
                <img src={PRODUCT_IMG} alt="MegaPack Maestría Reiki" className="w-full object-cover block mix-blend-screen" data-id="element-240" />
              </div>
            </div>
          </div>
        </div>

        {/* Pills */}
        <div className="flex justify-center gap-2 mb-4" data-id="element-241">
          <span className="text-[10px] sm:text-xs text-gray-200 font-medium bg-white/5 border border-white/15 rounded-full px-2.5 py-1 whitespace-nowrap" data-id="element-242">
            📄 100% PDF
          </span>
          <span className="text-[10px] sm:text-xs text-gray-200 font-medium bg-white/5 border border-white/15 rounded-full px-2.5 py-1 whitespace-nowrap" data-id="element-243">
            ⚡ Acceso en 5 min
          </span>
          <span className="text-[10px] sm:text-xs text-gray-200 font-medium bg-white/5 border border-white/15 rounded-full px-2.5 py-1 whitespace-nowrap" data-id="element-244">
            🇦🇷 Argentina
          </span>
        </div>

        {/* CTA */}
        <div className="flex flex-col items-center gap-2 w-full max-w-md mx-auto" data-id="element-245">
          <a href="#pricing-offer" className="w-full block px-4 py-3.5 md:py-4 rounded-xl text-[#0f0f1a] font-bold text-sm sm:text-base tracking-wider uppercase transition-all shadow-[0_0_30px_rgba(234,179,8,0.4)] hover:shadow-[0_0_40px_rgba(234,179,8,0.6)] hover:-translate-y-1 bg-[#eab308] hover:bg-[#d4a017] border border-[#eab308]/50 text-center" style={{
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-246">
            → QUIERO MI MEGAPACK AHORA
          </a>
          <p className="text-gray-400 text-[10px] md:text-xs font-medium" data-id="element-247">
            🛡️ Garantía 7 días | 🔒 Pago seguro | 💳 Mercado Pago
          </p>
        </div>
      </div>
    </section>;
}